// extracted by mini-css-extract-plugin
module.exports = {"label":"CardLabel_label__Qv2JK"};